const getters = {
  userInfo: state => state.user.info,
  keyWord: state => state.user.keyWord,
  token: state => state.user.token
}

export default getters
